import {docs_deleteCodiDocumentRow_Api} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {UseConfirmDeleteAction} from 'views/Document/CodiDocumentContext'
import {AdvancedActionGroups} from 'views/NewTemplate/components/AdvancedActionGroups'
import {DefaultActionButton} from 'views/NewTemplate/components/AdvancedActionGroups/ActionGroup'
import {RequiredSystemAdmin} from 'components/RequiredAdmin'
import {NullAsDefault, renderIf} from 'views/Shared'
import {CodiActions, CodiContentTypes} from './codiHelpers'
import {notifyOnError} from '../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../factory/createNotification'
import CodiContext from './CodiContext'
import {SelectedCodiRow} from './CodiCurrentDetail'
import LoadingBlock from "../../LoadingBlock";

const CodiRowContentGroup = ({title, description}) => {
    const t = useTranslate()

    const {
        item,
        asyncRowDetail,
        system_row,
        onRefresh = NullAsDefault,
        handleAction = NullAsDefault,
    } = useContext(CodiContext)

    const {id: row_id, index_typecd} = system_row ?? {}

    const codi_id = getId(item)

    const options = {
        insert_content: {
            title: 'insert content',
            label: 'insert',
            value: CodiActions.SHOW_INSERT_CONTENT_MODAL,
            type: 'primary',
            className: 'bg-green-600 hover:bg-green-700 text-white',
            description: 'insert content description',
        },
        edit_content: {
            title: 'edit content',
            label: 'edit',
            value: CodiActions.SHOW_EDIT_CONTENT_MODAL,
            type: 'primary',
            description: 'edit contents description',
        },
        rearrange_content: {
            title: 'arrange content',
            label: 'order',
            value: CodiActions.SHOW_REARRANGE_CONTENT_MODAL,
            type: 'primary',
            className: 'bg-indigo-500 hover:bg-indigo-600 text-white',
            description: 'arrange content description',
        },
        delete_content: {
            title: 'delete content',
            label: 'delete',
            value: CodiActions.DELETE_CONTENT,
            danger: true,
            type: 'primary',
            description: 'delete content description',
        },
        update_content_type: {
            title: 'change type index typecd',
            label: 'change',
            value: CodiActions.SHOW_UPDATE_ROW_TYPE_MODAL,
            type: 'primary',
            description: 'change type index typecd description',
        },
    }

    const isDisabled = useCallback(
        (action) => {
            if (
                [
                    CodiActions.SHOW_INSERT_CONTENT_MODAL,
                    CodiActions.SHOW_REARRANGE_CONTENT_MODAL,
                ].includes(action)
            ) {
                return index_typecd === CodiContentTypes.CONTENT
            }
            return false
        },
        [index_typecd]
    )

    if (Boolean(asyncRowDetail?.isLoading)) {
        return <LoadingBlock/>
    }

    return renderIf(
        Object.values(CodiContentTypes).includes(index_typecd),
        <div className="flex flex-col gap-2">
            <AdvancedActionGroups.ActionGroup
                title={title}
                description={description}>
                {[
                    options.insert_content,
                    options.edit_content,
                    // options.rearrange_content,
                    options.update_content_type,
                ].map(({value, title, description, ...rest}, index) => (
                    <AdvancedActionGroups.SimpleActionWrapper
                        key={index}
                        title={title}
                        description={description}>
                        <DefaultActionButton
                            onClick={() => {
                                handleAction(value)
                            }}
                            description={description}
                            disabled={isDisabled(value)}
                            {...rest}
                        />
                    </AdvancedActionGroups.SimpleActionWrapper>
                ))}
                <UseConfirmDeleteAction
                    onError={notifyOnError(t)}
                    title="Delete this content"
                    message="You want to delete this content"
                    apiInfo={docs_deleteCodiDocumentRow_Api}
                    onSuccess={() => {
                        successNotify(NotificationActionTypes.DELETE, t)
                        onRefresh()
                    }}>
                    {({isLoading = false, confirm = NullAsDefault}) => {
                        const {value, title, description, ...rest} =
                            options.delete_content
                        return (
                            <AdvancedActionGroups.SimpleActionWrapper
                                title={title}
                                description={description}>
                                <DefaultActionButton
                                    onClick={() => {
                                        if (row_id) {
                                            confirm({}, {row_id, id: codi_id})
                                        }
                                    }}
                                    isLoading={isLoading}
                                    description={description}
                                    {...rest}
                                />
                            </AdvancedActionGroups.SimpleActionWrapper>
                        )
                    }}
                </UseConfirmDeleteAction>
            </AdvancedActionGroups.ActionGroup>
        </div>
    )
}

const CodiRowManagement = ({style, className}) => {
    const {item, asyncRowDetail} = useContext(CodiContext)
    const isLoading = Boolean(asyncRowDetail?.isLoading)
    if (isLoading) {
        return <LoadingBlock/>
    }
    return (
        <RequiredSystemAdmin type={"codi_document"}>
            <div
                style={style}
                className={classNames('flex flex-col gap-2', className)}>
                <SelectedCodiRow/>
                <CodiRowContentGroup
                    title="edit content"
                    description="edit content description"
                />
            </div>
        </RequiredSystemAdmin>
    )
}

export default CodiRowManagement
